import React, { useState } from "react";
import { retrieveCaProfile } from "../../lib/caProfile";
import CaHeader from "../../components/ca/CaHeader";
import CaForm25Register from "../../components/ca/CaForm25Register";
import CaContactUsModal from "../../components/ca/CaContactUsModal";
import "../../styles/ca-form25.scss";

export default function CaForm25Page() {
  const [profile] = useState(() => retrieveCaProfile());
  const [contactOpen, setContactOpen] = useState(false);
  const [selectedClinicId, setSelectedClinicId] = useState(
    () => profile.clinics[0]?.clinicId ?? "",
  );

  return (
    <div className="ca-portal-page">
      <CaHeader
        profile={profile}
        onContactClick={() => setContactOpen(true)}
      />
      <main className="ca-form25-content">
        <CaForm25Register
          profile={profile}
          selectedClinicId={selectedClinicId}
          onClinicChange={setSelectedClinicId}
        />
      </main>
      <CaContactUsModal
        show={contactOpen}
        onClose={() => setContactOpen(false)}
        profile={profile}
        selectedClinicId={selectedClinicId}
      />
    </div>
  );
}
